<div class="form-field">
  @if (name) {
    <label class="label" [class.bold]="bold" [attr.for]="inputId">
      <span>{{name}}</span>
    </label>
  }
  <input
    [formControl]="control"
    [placeholder]="placeholder"
    [type]="formControlType"
    class="form-control"
    autocomplete="off"
    maxlength="6"
    type="text"
    inputmode="numeric"
    >
  <div class="actions">
    <ng-content></ng-content>
  </div>
  @if (showError) {
    <div class="input-error">
      <span>{{errorPresentation}}</span>
    </div>
  }
</div>
